import { createContext, useContext, createSignal, onCleanup, createEffect } from "solid-js";
const DropdownContext = createContext();

export const DropdownProvider = ( props ) => {
	const [activeId, setActiveId] = createSignal( null );

	const toggle = ( id ) => {
		setActiveId( ( prev ) => ( prev === id ? null : id ) );
	};
  createEffect(() => {
    if (!activeId()) return;

    const handleClick = (e) => {
      // Only close if click isn't inside a dropdown
		if ( !e.target.closest( ".dropdown" ) ) {
			document.removeEventListener( "click", handleClick );
        	setActiveId(null);
      }
    };

    document.addEventListener("click", handleClick);
    onCleanup(() => document.removeEventListener("click", handleClick));
  } );
	
	const store = { activeId, toggle, setActiveId };
	return (
		<DropdownContext.Provider value={store}>
			{props.children}
		</DropdownContext.Provider>
	);
};

export const useDropdownGroup = () => useContext( DropdownContext );